const service = () => {
	const protect_text = document.querySelector('.js-service-point__protect__title');
	if(protect_text !== null){
		protect_text.addEventListener('click', () => {
			protect_text.classList.toggle('is-open');
			slide_toggle(protect_text.nextElementSibling);
		});
	}
}